(ns web3.screens.loading
  (:require [web3.components.progress :as progress]))

(defn loading-screen []
  [:div.pad-h-4.margin-h-2.flex.items-center
   {:style {:height "100vh"
            :width "100%"}} [progress/indeterminate {:color "#03839c"}]])